import * as constants from './dashboard-constants';
import checkStatus from '../../../utils/checkStatus.js';
import s3 from '../../../utils/s3ContractingFilesUpload';
import { getIn } from '../../../utils/functional';

const credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
};

const put = body => Object.assign({ method: 'put', body }, credentialsAndHeaders);
function callApiGet(url, type) {
  return dispatch => {
    return fetch(`/proxy/contracting/${url}`, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    })
    .then(response => {
      dispatch({ type: constants[type], payload: response });
    });
  };
}

function callApiPut(url, type, body) {
  return dispatch => {
    return fetch(`/proxy/contracting/${url}`, {
      method: 'put',
      body: JSON.stringify(body),
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      if (res.body && res.json) return res.json();
      return {};
    })
    .then(response => {
      return dispatch({ type, payload: body });
    });
  };
}

export function changeContractState(state, contractIds) {
  return dispatch => {
    const payload = {
      contractIds,
      state,
    };
    dispatch({ type: 'CHANGE_CONTRACT_STATE_STARTING', payload });
    return fetch('/proxy/contracting/updateContractStatus', put(JSON.stringify({
      contractIds: Object.keys(contractIds),
      state,
    })))
    .then(checkStatus)
    .catch(err => console.log(err));
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dashboard/dashboard-actions.js